<forge-menu [options]="menuOptions()" (forge-menu-open)="menuOpened($event)" placement="bottom" [dense]="compactMode"
    forge-ignore (forge-menu-select)="loadQueryItemSelected($event)" style="pointer-events: auto;">
    <forge-icon-button telemetry="Load-Saved-Query" [dense]="compactMode" aria-label="Saved Queries">
        <forge-icon name="history"></forge-icon>
        <forge-tooltip placement="bottom">Saved Queries</forge-tooltip>
    </forge-icon-button>
</forge-menu>